import I18n from 'i18n-js'
import extend from 'lodash/extend'

window.I18n = I18n

I18n.extend = extend
I18n.defaultLocale = 'en'
I18n.locale = 'en'
